import * as tslib_1 from "tslib";
import { memoizeFunction } from '../../../Utilities';
import { mergeStyleSets } from '../../../Styling';
// @TODO Remove this tslint disable statement after the styles are converted
// to the updated mergeStyles method.
/* tslint:disable */
export function highContrastActive(styles) {
    return {
        '@media screen and (-ms-high-contrast: active)': styles
    };
}
export function focusClear() {
    return {
        '&::-moz-focus-inner': {
            border: 0
        },
        '&': {
            outline: 'transparent'
        }
    };
}
/* tslint:enable */
export var getClassNames = memoizeFunction(function () {
    return mergeStyleSets({
        root: {
            position: 'absolute',
            boxSizing: 'border-box',
            border: '1px solid ${}',
            selectors: tslib_1.__assign({}, highContrastActive({
                border: '1px solid WindowText'
            }), focusClear())
        },
        container: {
            position: 'relative'
        },
        main: {
            backgroundColor: '#ffffff',
            overflowX: 'hidden',
            overflowY: 'hidden',
            position: 'relative'
        },
        overFlowYHidden: {
            overflowY: 'hidden'
        }
    });
});
//# sourceMappingURL=PositioningContainer.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Coachmark/PositioningContainer/PositioningContainer.styles.js
// module id = 690
// module chunks = 0